export const Config = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
            <g>
                <path fill="currentColor"
                      d="M9.954 2.21a9.99 9.99 0 0 1 4.091-.002A3.994 3.994 0 0 0 16 5.07a3.993 3.993 0 0 0 3.457.261A9.99 9.99 0 0 1 21.5 8.876 3.994 3.994 0 0 0 20 12a3.99 3.99 0 0 0 1.502 3.124 10.041 10.041 0 0 1-2.046 3.543 3.992 3.992 0 0 0-3.456.261 3.994 3.994 0 0 0-1.954 2.86 9.99 9.99 0 0 1-4.09.004 3.994 3.994 0 0 0-3.655-3.39 3.991 3.991 0 0 0-1.758.265A9.99 9.99 0 0 1 2.5 15.121 3.993 3.993 0 0 0 4 11.999a3.993 3.993 0 0 0-1.502-3.124 10.043 10.043 0 0 1 2.046-3.543A3.993 3.993 0 0 0 8 5.071a3.993 3.993 0 0 0 1.954-2.86V2.21ZM12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"/>
            </g>
        </svg>
    );
};